import { ClassRelation } from "@model/class-relation";
import { HorizonClassRelation } from "@model/horizon-class-relation";
import {HorizonStudent} from "@model/horizon-student";
import { getDateTime } from "@shared/util/date-util";

export interface EleveHorizonDto {
  id: string;
  prenom: string;
  nom: string;
  dateNaissance: string;
  lieuNaissance: string;
  nationalite: string;
  numeroNational: string;
  situationAnnees: SituationAnneeDto[];
}

interface SituationAnneeDto {
  anneeScolaire: number;
  dateDebut: string;
  dateFin: string;
  classe: ClasseDto;
}

interface ClasseDto {
  anneeScolaire: number;
  codeAnneeEtude: string;
  codeClasse: string;
  codeSielAnneEtude: string;
  faseEtablissement: number;
  faseImplantation: number;
}

export const EleveHorizonDtoMapper = {
  toDomain: (dto: EleveHorizonDto, currentSchoolYear: number): HorizonStudent => ({
    id: dto.id,
    firstName: dto.prenom,
    lastName: dto.nom,
    birthDate: dto.dateNaissance,
    birthPlace: dto.lieuNaissance,
    inss: dto.numeroNational,
    currentClass: extractCurrentClass(dto.situationAnnees, currentSchoolYear),
    classHistory: extractClassHistory(dto.situationAnnees)
  })
};

function extractCurrentClass(situations: SituationAnneeDto[], currentSchoolYear: number): string {
  const currentSituation = situations
    .filter(s => s.classe.anneeScolaire == currentSchoolYear)
    .find(s => !s.dateFin);
  if (currentSituation) {
    return `${currentSituation.classe.codeAnneeEtude} ${currentSituation.classe.codeClasse}`;
  }
  return '';
}

function extractClassHistory(situations: SituationAnneeDto[]): HorizonClassRelation[] {
  return situations.map(s => ({
    year: s.anneeScolaire,
    className: `${s.classe.codeAnneeEtude} ${s.classe.codeClasse}`,
    startDate: s.dateDebut ? getDateTime(s.dateDebut) : null,
    endDate: s.dateFin ? getDateTime(s.dateFin) : null,
    schoolEstablishmentFase: s.classe.faseEtablissement,
    schoolImplantationFase: s.classe.faseImplantation,
    code: s.classe.codeClasse,
    yearOfStudy: s.classe.codeAnneeEtude,
  }));
}